// App-level registrations (plugins, mixins, directives, Sentry) applied to the
// Vue 3 app created in LiveCaller.liftOff().
import * as Sentry from '@sentry/vue'
import ErrorPage from '@/plugins/error-page'
import StoragePlugin from '@/plugins/storage'
import lineClamp from '@/directives/line-clamp'
import linkify from '@/directives/linkify'
import ObserveVisibility from '@/directives/observe-visibility'
import canDirective from '@/directives/can'
import tooltipDirective from '@/directives/tooltip'
import TranslationsMixin from '@/mixins/Translations'

const errorPages = import.meta.glob('./views/pages/errors/*.vue', { eager: true, import: 'default' })

export default function registerGlobals(app) {
    if (import.meta.env.VUE_APP_SENTRY_DSN && import.meta.env.VUE_APP_ENVIRONMENT) {
        Sentry.init({
            app,
            tracesSampleRate: 0.1,
            dsn: import.meta.env.VUE_APP_SENTRY_DSN,
            integrations: [
                Sentry.browserTracingIntegration(),
            ],
            environment: import.meta.env.VUE_APP_ENVIRONMENT,
        })
    }

    app.use(ErrorPage, {
        tagName: 'app-view',
        event: 'error-page',
        resolver: (component) => errorPages[`./views/pages/errors/${component}.vue`],
    })
    app.use(StoragePlugin)

    // The only global mixin left: the template-facing `__()` translation helper.
    // Everything else moved to composables (useToast) or @/shared utilities.
    app.mixin(TranslationsMixin)

    app.directive('can', canDirective)
    app.directive('linkify', linkify)
    app.directive('line-clamp', lineClamp)
    app.directive('observe-visibility', ObserveVisibility)
    app.directive('tooltip', tooltipDirective)
}
